import type { PublicApiCommand, PublicApiContext, PublicApiResult } from "@/lib/public-api/types";

/**
 * Scaffold only — not wired to WhatsMeow yet.
 * Expected params (draft):
 * - chatId: international phone digits or WhatsApp JID user part
 * - text: message body
 */
export const sendMessageCommand: PublicApiCommand = {
  name: "sendMessage",
  summary: "Send a text message to a chat",
  description:
    "Queues a plain-text WhatsApp message from this device. chatId is the recipient number in international format (digits only) or a full JID. Implementation is stubbed until messaging is connected.",
  exampleBody: {
    command: "sendMessage",
    params: {
      chatId: "972501234567",
      text: "Hello from MyAPI",
    },
  },
  async handle(ctx: PublicApiContext): Promise<PublicApiResult> {
    const chatId = String(ctx.params.chatId ?? "").trim();
    const text = String(ctx.params.text ?? "");

    if (!chatId) {
      return {
        ok: false,
        code: "INVALID_PARAMS",
        error: "params.chatId is required",
      };
    }
    if (!text) {
      return {
        ok: false,
        code: "INVALID_PARAMS",
        error: "params.text is required",
      };
    }
    if (text.length > 4096) {
      return {
        ok: false,
        code: "INVALID_PARAMS",
        error: "params.text is too long (max 4096)",
      };
    }

    // Infrastructure placeholder — real WhatsMeow send comes later.
    return {
      ok: false,
      code: "NOT_IMPLEMENTED",
      error: "sendMessage is registered but not connected to WhatsMeow yet",
      details: {
        deviceUid: ctx.device.uid,
        chatId,
        textLength: text.length,
        deviceRunning: ctx.device.desiredRunning,
        devicePaired: ctx.device.isPaired,
      },
    };
  },
};
